module.exports = __webpack_public_path__ + "img/icon-come-funziona-presentati.22ff7f10.svg";